import React from 'react'
import { FormGroup, ControlLabel } from 'react-bootstrap'
import { T } from 'components/components/i18n'
import Checkbox from '../../../Checkbox'
import { getQualitySearchTypes, getVisibleQualityTypes } from 'helpers/quality'

const qualityLabels = {
  premium: <T id="Premium"/>,
  medium: <T id="Medium"/>,
  budget: <T id="Budget"/>
}

export class Quality extends React.Component {
  constructor(props) {
    super(props)
    const visibleOptions = this.getVisibleOptions(props)
    this.state = {
      selectedOptions: this.getSelectedOptions(props, visibleOptions)
    }
    this.handleCheckboxChange = this.onCheckboxChange.bind(this)
  }

  componentWillReceiveProps(newProps) {
    const visibleOptions = this.getVisibleOptions(newProps)
    this.setState({
      selectedOptions: this.getSelectedOptions(newProps, visibleOptions)
    })
  }

  getVisibleOptions(props = this.props) {
    return getVisibleQualityTypes(props.config, props.productType)
  }

  getSelectedOptions(props, visibleOptions) {
    const selectedOptions = props.defaultQualityOptions || []
    return selectedOptions.filter(option => visibleOptions.indexOf(option) !== -1)
  }

  onCheckboxChange(value) {
    let  selectedOptions
    const checked = this.state.selectedOptions.indexOf(value) !== -1
    if (checked)
      selectedOptions = this.state.selectedOptions.filter(option => option !== value)
    else {
      selectedOptions = this.state.selectedOptions.slice()
      selectedOptions.push(value)
    }
    this.setState({
      selectedOptions
    }, this.setQualitySearchParam.bind(this))
  }

  setQualitySearchParam() {
    const visibleOptions = this.getVisibleOptions()
    const selectedOptions = getQualitySearchTypes(this.state.selectedOptions, visibleOptions)
    this.props.onChange('quality', selectedOptions)
  }

  render () {
    const visibleOptions = this.getVisibleOptions()
    if (!visibleOptions.length)
      return null

    const quality = visibleOptions.map(option => {
      return (
        <Checkbox
          onChange={() => this.handleCheckboxChange(option)}
          value={option}
          key={option}
          label={qualityLabels[option]}
          isChecked={this.state.selectedOptions.indexOf(option) > -1}
        />
      )
    })
    return (
      <FormGroup className="tyre-quality">
        <ControlLabel>
          <T id="Quality"/>
        </ControlLabel>
        <div>{quality}</div>
      </FormGroup>
    )
  }
}

export default Quality
